import xrmApiAnonymous from "src/services/xrmApi"
import { xRMApiProduct, xRMApiProductVariant } from "src/types/xRM"

export const getProductVariants = async (
  product: Pick<xRMApiProduct, "id" | "parentCategoryId">,
): Promise<xRMApiProductVariant[]> => {
  return xrmApiAnonymous
    .get(
      `/product/variants?productId=${product.id}&categoryId=${product.parentCategoryId}&exhibitionId=${process.env.NEXT_PUBLIC_WEBSHOP_XRM_EVENT_ID}`,
    )
    .then((res) => res?.data ?? [])
}
